import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../store";

interface IDesignPhotoInfo {
    designPhotoId: string;
}

interface IDesignPhoto {
    info: IDesignPhotoInfo;
}

const initialState: IDesignPhoto = {
    info: {
        designPhotoId: "",
    },
};

export const designPhotoSlice = createSlice({
    name: "designPhoto",
    initialState,
    reducers: {
        setDesignPhotoInfo: (state, action: PayloadAction<IDesignPhoto>) => {
            state.info = action.payload.info;
        },
    },
});

export const { setDesignPhotoInfo } = designPhotoSlice.actions;

export const selectDesignPhotoInfo = (state: RootState) => state.designPhoto.info;

export default designPhotoSlice.reducer;
